module.exports = __webpack_public_path__ + "img/logo-onix.b7278be0.png";